import { ReactNode } from 'react';

import Arrows from 'assets/svg/arrows';
import BarCode from 'assets/svg/bar-code';
import Clock from 'assets/svg/clock';

import './list.styles.scss';

type BizosListProps = {
    children?: ReactNode;
};

const BizosList = ({ children }: BizosListProps) => {
    return (
        <ul className="bizos-list">
            {children}
        </ul>
    );
}

const icons = {
    arrows: <Arrows />,
    clock: <Clock />,
    barcode: <BarCode />,
}

 type Icon =  keyof typeof icons;

type BizosListItemProps = {
    color?: 'light-gray' | 'gray';
    icon: Icon;
    children?: ReactNode;
}

export const BizosListItem = ({ color = 'light-gray', icon, children }: BizosListItemProps) => {
    return (
        <li className={`bizos-list__item ${color}`}>
            <div className="bizos-list__icon">
                {icons[icon]}
            </div>
            <span>{children}</span>
        </li>
    )
}

export default BizosList;
